import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../redux/actions";

import AWSAppSyncClient from "aws-appsync";
import config from "../aws-exports";
import { Auth } from "aws-amplify";

const client = new AWSAppSyncClient({
  url: config.aws_appsync_graphqlEndpoint,
  region: config.aws_appsync_region,
  disableOffline: true,
  auth: {
    type: config.aws_appsync_authenticationType,
    apiKey: config.aws_appsync_apiKey,
    jwtToken: async () =>
      (await Auth.currentSession()).getAccessToken().getJwtToken()
  }
});
class mySignOut extends Component {
  state = {};
  componentDidMount() {
    Auth.signOut()
      .then(() => {
        this.props.storeUser(null);
        this.props.storeProfile(null);
        this.props.userLogout(null);
        this.props.storeClient(client);
      })
      .catch(() => this.props.storeUser(null));
  }
  render() {
    return null;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    storeUser: data => dispatch(actionTypes.storeUser(data)),
    userLogout: data => dispatch(actionTypes.userLogout(data)),
    storeProfile: data => dispatch(actionTypes.storeProfile(data)),
    storeClient: data => dispatch(actionTypes.storeClient(data))
  };
};
export default mySignOut = connect(
  null,
  mapDispatchToProps
)(mySignOut);



// WEBPACK FOOTER //
// ./src/auth/signOut.js